import { Typography } from '@robinpowered/ui-kit';
import { useTranslation } from 'react-i18next';

export const Loading = () => {
  const { t } = useTranslation('common');
  return <Typography.Text>{t('Loading.loading')}</Typography.Text>;
};
